import React from 'react';
import Relay from 'react-relay';

import isSold from 'depop/utils/isSold';

import InvalidProductListItem from './InvalidProductListItem';

import ProductLink from 'depop/apps/shops/links/ProductLink';

import Picture from 'depop/components/images/Picture';

import { style, media, active } from 'glamor';
import { formatProductPrice } from 'depop/utils/money';
import { trackProductCardClick } from 'depop/utils/tracking';

class ProductListItem extends React.Component {
  props: {
    product: Object,
    from: ?string,
    productListIndex: number,
    listName: string
  };

  trackClick = () => {
    trackProductCardClick({
      id: this.props.product.publicId,
      index: this.props.productListIndex,
      listName: this.props.listName,
    });
  };

  render() {
    const { product, from, productListIndex } = this.props;

    if (!product.picture) {
      return <InvalidProductListItem />;
    }

    return (
      <ProductLink
        {...style({position: 'relative', textDecoration: 'none', color: 'inherit'})}
        product={product}
        onClick={this.trackClick}
        from={from}
        listIndex={productListIndex}>
        <div {...style({position: 'relative', background: 'black'})}>
          <div {...active({opacity: '0.8'})}>
            <Picture picture={product.picture} />
          </div>
          {isSold(product)
            ? <div {...style({
              position: 'absolute',
              fontSize: 14,
              bottom: 0,
              left: 0,
              backgroundColor: '#f9ec00',
              color: '#000',
              padding: '4px 15px',
            })}>Sold</div>
            : null}
        </div>
        <div
          {...style({
            display: 'none',
            margin: '10px 0 calc(10px - 0.5vw)',
            maxWidth: '100%',
            width: '12em',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            fontSize: 14,
            textOverflow: 'ellipsis',
          })}
          {...media('(min-width: 701px)', { display: 'block' })}>
          {formatProductPrice(product.price.display, product.price.currencySymbol)}</div>
      </ProductLink>
    );
  }
}

export default Relay.createContainer(ProductListItem, {
  fragments: {
    product: () => Relay.QL`
      fragment on Product {
        ${ProductLink.getFragment('product')}
        publicId
        slug
        saleStatus
        price {
          currencySymbol
          display
        }
        picture {
          ${Picture.getFragment('picture')}
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/ProductList/ProductListItem.js